import axios from "axios";
import jwt_decode from "jwt-decode";
import { persistor } from "./redux/store";
import { Environment } from "./environment/environment";

axios.defaults.baseURL = `${Environment.BASE_API}`;

// De-duplicate concurrent refresh requests across the app
let refreshPromise = null;

const refreshToken = async (token, dispatch, navigate) => {
  try {
    const res = await axios.post("/refresh", { token });
    return res.data;
  } catch (err) {
    console.log(err);
    dispatch({ type: "RESET_ALL" });
    await persistor.purge();
    navigate("/login");
    throw err;
  }
};

export const createAxios = (user, dispatch, stateSuccess, navigate) => {
  const instance = axios.create({ baseURL: Environment.BASE_API });

  instance.interceptors.request.use(
    async (config) => {
      try {
        const now = Date.now() / 1000;
        const decoded = user?.accessToken ? jwt_decode(user.accessToken) : null;
        const isExpired = decoded ? decoded.exp < now : true;

        if (isExpired && user?.refreshToken) {
          if (!refreshPromise) {
            refreshPromise = refreshToken(user.refreshToken, dispatch, navigate).finally(() => {
              refreshPromise = null;
            });
          }
          const data = await refreshPromise;
          const refreshUser = {
            ...user,
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
          };
          dispatch(stateSuccess(refreshUser));
          config.headers["token"] = `Bearer ${data.accessToken}`;
        } else if (user?.accessToken) {
          config.headers["token"] = `Bearer ${user.accessToken}`;
        }
      } catch (_) {
        // proceed; server can still reject unauthorized requests
      }
      return config;
    },
    (err) => Promise.reject(err)
  );

  return instance;
};

